import styled from 'styled-components';
import { Box, Typography, Button, Paper, Container, Stack, IconButton } from '@mui/material';

export const Card = styled(Paper)({
  '&&': {
    background: '#fff',
    borderRadius: 10,
    boxShadow: 'none',
    padding: 24,
    marginBottom: 24,
    width: '100%',
    boxSizing: 'border-box',
  },
});
Card.defaultProps = { elevation: 0 };

export const JumpToCard = styled(Card)({
  display: 'flex',
  alignItems: 'center',
  padding: 20,
  marginBottom: 24,
  background: '#F9FAFB',
  boxShadow: 'none',
  borderRadius: 10,
});

export const LocationCard = styled(Card)({
  marginBottom: 24,
  background: '#fff',
  boxShadow: 'none',
  borderRadius: 10,
});

export const OrderDetailsCard = styled(Card)({
  marginBottom: 24,
  background: '#fff',
  boxShadow: 'none',
  borderRadius: 10,
});

export const PayloadCard = styled(Card)({
  '&&': {
    marginBottom: 24,
    background: '#fff',
    boxShadow: 'none',
    padding: 0,
    borderRadius: 10,
  },
});

export const PayloadCardHeader = styled(Box)({
  padding: '20px 24px 0 24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const PayloadCardContent = styled(Box)({
  padding: '0 24px 24px 24px',
});

export const PageContainer = styled(Box)({
  minHeight: '100vh',
  backgroundColor: '#F4F6FA',
  padding: '32px 0',
});

export const ContentWrapper = styled(Container)({
  paddingTop: 0,
  paddingBottom: 0,
  maxWidth: '1280px',
});

export const HeaderSection = styled(Box)({
  marginBottom: 24,
});

export const OrderNumber = styled(Typography)({
  color: '#656d76',
  paddingBottom: '16px',
});

export const HeaderTitle = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  marginBottom: '0',
});

export const TitleText = styled(Typography)({
  '&&': {
    fontWeight: 600,
    color: '#24292f',
    fontSize: '24px',
    fontFamily: 'Inter',
  },
});

export const StatusIndicator = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  color: '#1a7f37',
  fontSize: '0.875rem',
  background: '#E7F6EC',
  borderRadius: 6,
  padding: '2px 12px',
  fontWeight: 500,
});

export const JumpToSection = styled(Box)({
  marginBottom: 0,
  width: '100%',
});

export const JumpToTitle = styled(Typography)({
  color: '#656d76',
  marginRight: 16,
  fontWeight: 500,
  fontSize: 15,
  minWidth: 70,
  '&&': {
    marginBottom: '16px',
  },
});

export const JumpToButtons = styled(Stack)({
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '8px',
  width: '100%',
});

export const JumpToButton = styled(Button)({
  '&&': {
    color: '#1B51A4',
    border: '1px solid #1B51A4',
    textTransform: 'capitalize',
    fontSize: '0.875rem',
    fontWeight: 500,
    minWidth: 'unset',
    flex: '0 0 auto',
    padding: '6px 12px 6px 8px',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    backgroundColor: '#fff',
    '@media (max-width: 768px)': {
      fontSize: '0.8rem',
      padding: '4px 8px 4px 6px',
      gap: 4,
    },
  },
});

export const CopyAllButton = styled(Button)({
  '&&': {
    backgroundColor: '#1B51A4',
    color: 'white',
    textTransform: 'none',
    fontSize: '0.875rem',
    fontWeight: 500,
    minWidth: '90px',
    flex: '0 0 auto',
    padding: '6px 12px',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    '@media (max-width: 768px)': {
      fontSize: '0.8rem',
      minWidth: '80px',
      padding: '4px 8px',
    },
  },
  '&:hover': {
    backgroundColor: '#174484',
  },
});

export const InfoSection = styled(Box)({
  marginBottom: 0,
});

export const InfoLabel = styled(Typography)({
  color: '#656d76',
  marginBottom: '4px',
  fontWeight: 500,
  fontSize: 15,
});

export const InfoValue = styled(Typography)({
  color: '#24292f',
  fontSize: 16,
  fontWeight: 400,
  marginTop: '4px',
});

export const MonospaceValue = styled(InfoValue)({
  fontFamily: 'monospace',
  background: '#F3F4F6',
  borderRadius: 6,
  padding: '5px 8px',
  fontSize: 15,
});

export const OrderDetailsSection = styled(Box)({
  marginBottom: 0,
});

export const SectionTitle = styled(Typography)({
  '&&': {
    marginBottom: '24px',
  },
  fontWeight: 600,
  color: '#24292f',
  fontSize: 18,
});

export const PayloadSection = styled(Box)({
  marginBottom: 0,
});

export const PayloadHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '8px',
});

export const PayloadTitle = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const PayloadNumber = styled(Box)({
  minWidth: '20px',
  minHeight: '20px',
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  backgroundColor: '#1B51A4',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '0.8rem',
  fontWeight: 600,
  flexShrink: 0,
  '@media (max-width: 768px)': {
    minWidth: '18px',
    minHeight: '18px',
    width: '18px',
    height: '18px',
    fontSize: '0.75rem',
  },
});

export const PayloadActions = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const CopyButton = styled(Button)({
  '&&': {
    textTransform: 'none',
  },
  fontSize: '0.875rem',
  borderColor: '#d0d7de',
  color: '#24292f',
  background: '#F3F4F6',
  borderRadius: 6,
  '&:hover': {
    borderColor: '#1B51A4',
    color: '#1B51A4',
    background: '#E3EFFF',
  },
});

export const CollapseButton = styled(IconButton)({
  color: '#666',
});

export const PayloadContent = styled(Paper)({
  backgroundColor: '#f6f8fa',
  border: '1px solid #d0d7de',
  borderRadius: '8px',
  padding: '24px',
  margin: 0,
  '& pre': {
    margin: 0,
    fontFamily: "'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace",
    fontSize: '0.875rem',
    lineHeight: 1.45,
    color: '#24292f',
    overflow: 'auto',
    maxHeight: '600px',
  },
});

export const CollapsedPayloadCard = styled(PayloadCard)({
  '&&': {
    paddingBottom: 20,
    borderRadius: 10,
  },
});

export const StickyJumpToCard = styled(JumpToCard)({
  '&&': {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    padding: '16px',
    marginBottom: 24,
    borderRadius: 10,
    '@media (max-width: 768px)': {
      padding: '12px',
    },
    '@media (max-width: 480px)': {
      padding: '8px',
    },
  },
});

export const JumpToButtonsScroll = styled('div')({
  display: 'flex',
  gap: 12,
  flexWrap: 'wrap',
  alignItems: 'center',
  paddingBottom: 4,
  '@media (max-width: 768px)': {
    gap: 8,
  },
  '@media (max-width: 480px)': {
    gap: 6,
  },
});

export const JsonDisplayBox = styled(Box)({
  backgroundColor: '#f6f8fa',
  border: '1px solid #d0d7de',
  borderRadius: '6px',
  padding: '20px',
  margin: 0,
  fontFamily: "'Inter', 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace",
  fontSize: '0.875rem',
  fontWeight: 400,
  color: '#24292f',
  lineHeight: 1.6,
  overflowX: 'auto',
  '& .object-key': {
    color: '#1B51A4 !important',
    fontWeight: 500,
  },
  '& .object-content .object-key-val, & .object-content .variable-row': {
    borderColor: '#ddd !important',
  },
  '& .json-tree': {
    fontFamily: "'Inter', 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace",
    fontSize: '0.875rem',
  },
  '& .json-tree__value': {
    color: '#24292f',
  },
  '& .json-tree__key': {
    color: '#1B51A4',
    fontWeight: 500,
  },
  '& .json-tree__string': {
    color: '#28a745',
  },
  '& .json-tree__number': {
    color: '#e36209',
  },
  '& .json-tree__boolean': {
    color: '#6f42c1',
  },
  '& .json-tree__null': {
    color: '#d73a49',
  },
}); 